import { LoginForm } from "./loginForm.tsx";
import { Grid, Heading } from "@idg-web-platform/pulse";
import { analyticsContentViewed } from "../../utils/analyticsContentViewed.ts";
import { useEffect } from "preact/hooks";
import css from "./logout.module.css";
import { AlertState, ManagedAlert } from "../../components/managedAlert/managedAlert.tsx";
import { useManagedAlert } from "../../components/managedAlert/useManagedAlert.ts";

WelcomeBackPage.tagName = "control-welcome-back-page";

/*
 * The welcome back page contains the login form without the registration form.
 * By default, it shows the logged out message.
 * The redirect property is used to redirect the user to the redirect path after login.
 * The alert can be customized using the customAlert prop to show information about club link validation outcome.
 */

export function WelcomeBackPage({ redirect, message }: LogoutPageProps) {
  const { alert, showAlert, closeAlert } = useManagedAlert();

  useEffect(() => {
    analyticsContentViewed(alertMessages[message][1]);
    showAlert(alertMessages[message][0]);
  }, []);

  return (
    <>
      <Grid>
        <div className={css.logoutPageContainer}>
          <div className="mono-1-narrow">
            <Heading sizeStep={2} text="Willkommen zurück" />
          </div>
          <ManagedAlert alert={alert} onClose={closeAlert} />
          <LoginForm redirect={redirect} />
        </div>
      </Grid>
    </>
  );
}

export interface LogoutPageProps {
  redirect: string;
  message: WelcomeBackMessage;
}

export enum WelcomeBackMessage {
  loggedOut,
  invalidClubVerificationLink,
  clubLinked,
}

const alertMessages: Record<WelcomeBackMessage, [AlertState, string]> = {
  [WelcomeBackMessage.loggedOut]: [
    {
      severity: "success",
      headline: "Abmeldung erfolgreich",
      description: "Du hast dich erfolgreich abgemeldet.",
    },
    "logout",
  ],
  [WelcomeBackMessage.invalidClubVerificationLink]: [
    {
      severity: "warning",
      headline: "Club-Mitgliedschaft",
      description:
        "Der Link ist leider ungültig. Bitte logge dich ein und fordere einen neuen Link an.",
    },
    "invalid_club_verification_link",
  ],
  [WelcomeBackMessage.clubLinked]: [
    {
      severity: "success",
      headline: "Willkommen im CLUB!",
      description:
        "Deine Clubmitgliedschaft wurde erfolgreich erstellt. Um alle wichtigen Information und Vorteile nutzen zu können, logge dich ein.",
    },
    "club_linked",
  ],
};
